import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";
import { Table } from "semantic-ui-react";

const UiMeet3dEventDetailsLead = observer(({ data, t }) => {
  return (
    <>
      <Table definition>
        <Table.Body>
          <Table.Row>
            <Table.Cell width={4}>{t("clientPanelMisc:name")}</Table.Cell>
            <Table.Cell>{data.user.name}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell width={4}>{t("clientPanelMisc:location")}</Table.Cell>
            <Table.Cell>
              {data.user.location.city ? data.user.location.city : t("clientPanelMisc:locationUnknown")}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
      <Table definition>
        <Table.Body>
          {Object.entries(data.formData.content).map(([key, value]) => (
            <Table.Row>
              <Table.Cell width={4}>{String(key)}</Table.Cell>
              <Table.Cell>{String(value)}</Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
});

UiMeet3dEventDetailsLead.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
};

export default withTranslation()(UiMeet3dEventDetailsLead);
